import { Link } from "react-router-dom";

import logo from "../../../assets/images/logo.svg";
import { useLanguage } from "../../../context/LanguageProvider";
import { ROUTES } from "../../constants/routes";

// Logo and brand name at the top of the card, linking to the home page
const BrandLogo = () => {
    const { lang, t } = useLanguage();

    return (
        <Link to={ROUTES.home(lang)} className="relative flex items-center mx-auto">
            <img src={logo} alt="" className="h-16 rounded-sm" />
            <span className="text-2xl font-bold text-light-primary">{t.nav.brand}</span>
        </Link>
    );
};

export default BrandLogo;